import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-ink text-paper">
      <div className="mx-auto max-w-5xl px-6 py-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <p className="font-display text-xs uppercase tracking-[0.25em] text-accent">
              Finance Operator-Builder
            </p>
            <p className="mt-3 font-display text-xl leading-snug">
              JL Patawaran
            </p>
            <p className="mt-1 text-sm text-paper/60">
              AI-Augmented Finance Operator
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-paper/50">
              Site
            </p>
            <ul className="mt-3 space-y-1.5 text-sm">
              <li>
                <Link to="/about" className="text-paper/80 hover:text-paper">
                  About
                </Link>
              </li>
              <li>
                <Link to="/proof" className="text-paper/80 hover:text-paper">
                  Proof
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-paper/80 hover:text-paper">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/articles" className="text-paper/80 hover:text-paper">
                  Articles
                </Link>
              </li>
              <li>
                <Link to="/work-with-me" className="text-paper/80 hover:text-paper">
                  Check fit
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-paper/50">
              Contact
            </p>
            <ul className="mt-3 space-y-1.5 text-sm">
              <li>
                <a
                  href="mailto:jl@jlpatawaran.com"
                  className="text-paper/80 hover:text-paper"
                >
                  jl@jlpatawaran.com
                </a>
              </li>
              <li className="text-paper/55">
                Async-first. Reply within two working days.
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-paper/10 pt-8 text-xs text-paper/55 sm:flex-row sm:items-start sm:justify-between">
          <p>© {new Date().getFullYear()} JL Patawaran.</p>
          <p className="max-w-md text-paper/50 sm:text-right">
            Articles may use AI-assisted research, outlining, drafting, and editing. Final claims and published judgment remain JL-reviewed.
          </p>
        </div>
      </div>
    </footer>
  );
}
